import moize from "moize";

export const clearMoizeCache = () => {
  const memoized = moize((item) => {
          return item;
        });
  memoized.clear();       
};

// Roof-zone helpers are memoized with isSerialized: true. The tech-upgrade
// path started passing the full Redux state as `stateConfig`, so every cache
// lookup JSON.stringified every panel. Master only serialized roof geometry.
export const omitStateConfigFromMemoArgs = (args: unknown[]) =>
  args.map((arg) => {
    if (!arg || typeof arg !== 'object' || Array.isArray(arg)) {
      return arg;
    }

    const { stateConfig, ...rest } = arg as { stateConfig?: unknown };
    return rest;
  });

